import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { UseToast } from '../../hooks/UseToast';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const toast = UseToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      
      const data = await res.json();
      
      if (data.success) {
        // Token save pannu
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        
        // useAuth context update pannu
        login(data.user, data.token);
        
        toast.success('Login successful!');
        navigate('/');
      } else {
        toast.error(data.message || 'Invalid credentials');
      }
    } catch (error) {
      toast.error('Login failed. Please try again.');
      console.error('Login error:', error);
    }
    
    setLoading(false);
  };

  return (
    <>
      <style>{`
        .login-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #667EEA 0%, #764BA2 100%); }
        .login-card { background: rgba(255,255,255,0.95); backdrop-filter: blur(20px); border-radius: 24px; padding: 50px 40px; width: 100%; max-width: 420px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
        .login-logo { text-align: center; margin-bottom: 30px; }
        .logo-icon { width: 70px; height: 70px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); border-radius: 16px; display: inline-flex; align-items: center; justify-content: center; font-size: 32px; color: #FFF; margin-bottom: 16px; }
        .login-title { font-size: 28px; font-weight: 800; color: #0F172A; margin: 0 0 8px 0; }
        .login-subtitle { color: #64748B; font-size: 15px; }
        .form-group { margin-bottom: 20px; }
        .input-wrapper { position: relative; }
        .input-icon { position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #94A3B8; font-size: 18px; }
        .form-input { width: 100%; padding: 14px 16px 14px 48px; border: 2px solid #E2E8F0; border-radius: 12px; font-size: 15px; transition: all 0.3s ease; box-sizing: border-box; }
        .form-input:focus { outline: none; border-color: #3B82F6; box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1); }
        .password-toggle { position: absolute; right: 16px; top: 50%; transform: translateY(-50%); background: none; border: none; color: #94A3B8; cursor: pointer; font-size: 18px; }
        .login-btn { width: 100%; padding: 14px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); color: #FFF; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.3s ease; }
        .login-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(59, 130, 246, 0.4); }
        .login-btn:disabled { opacity: 0.6; cursor: not-allowed; }
        .forgot-link { text-align: right; margin: 12px 0 20px 0; }
        .forgot-link a { color: #3B82F6; font-size: 14px; font-weight: 600; text-decoration: none; }
        .forgot-link a:hover { text-decoration: underline; }
      `}</style>
      <div className="login-page">
        <div className="login-card">
          <div className="login-logo">
            <div className="logo-icon">S</div>
            <h1 className="login-title">Admin Panel</h1>
            <p className="login-subtitle">Sign in to your account</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-wrapper">
                <FiMail className="input-icon" />
                <input 
                  type="email" 
                  className="form-input" 
                  placeholder="Email address" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                />
              </div>
            </div>
            <div className="form-group">
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input 
                  type={showPassword ? 'text' : 'password'} 
                  className="form-input" 
                  placeholder="Password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
                <button 
                  type="button" 
                  className="password-toggle" 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>
            {/* <div className="forgot-link">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div> */}
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};
export default Login;